"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SvgIcon = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _react = _interopRequireWildcard(require("react"));
var _manifest_svg_icons = _interopRequireDefault(require("./manifest_svg_icons"));
var _helpers = require("./_helpers");
var _SvgIconSource = require("./_SvgIconSource");
var _SvgIcon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SvgIcon.css") : void 0);
var _excluded = ["ariaHidden", "className", "iconName", "path1ClassName", "path2ClassName", "size", "title"]; // generated; see scripts/buildIconManifest.js
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-svg-icon';
var SvgIcon = exports.SvgIcon = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _context, _context2;
  var ariaHidden = _ref.ariaHidden,
    className = _ref.className,
    iconName = _ref.iconName,
    path1ClassName = _ref.path1ClassName,
    path2ClassName = _ref.path2ClassName,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    title = _ref.title,
    otherProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var themeProviderContext = (0, _react.useContext)(_reactUiTheming.ThemeProviderContext);
  var _ref2 = themeProviderContext || {},
    _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? 'concur_default' : _ref2$theme;
  var classnames = _bind.default.bind(_SvgIcon.default);
  var classes = classnames(CSS_BLOCK, className);
  var path1Classes = classnames("".concat(CSS_BLOCK, "__path1"), (0, _concat.default)(_context = "".concat(CSS_BLOCK, "__path1--")).call(_context, iconName), path1ClassName);
  var path2Classes = classnames("".concat(CSS_BLOCK, "__path2"), (0, _concat.default)(_context2 = "".concat(CSS_BLOCK, "__path2--")).call(_context2, iconName), path2ClassName);
  var iconSize = (0, _helpers.getIconPixelSize)(size, theme);
  var viewBox = (0, _helpers.getViewBox)(theme);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, otherProps, {
    role: !ariaHidden ? 'img' : undefined,
    "aria-hidden": !!ariaHidden,
    className: classes,
    height: iconSize,
    style: _objectSpread({
      enableBackground: "new ".concat(viewBox)
    }, otherProps === null || otherProps === void 0 ? void 0 : otherProps.style),
    version: "1.1",
    viewBox: viewBox,
    width: iconSize,
    x: "0px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    y: "0px",
    ref: ref
  }), title && /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement(_SvgIconSource.SvgIconSource, {
    iconName: iconName,
    path1ClassName: path1Classes,
    path2ClassName: path2Classes,
    theme: theme
  }));
});
SvgIcon.displayName = 'SvgIcon';
SvgIcon.propTypes = {
  /** The name of the desired messaging icon */
  iconName: _propTypes.default.oneOf(_manifest_svg_icons.default).isRequired,
  /** The value for the `aria-hidden` attribute. Set to `true` when there
   * is already visible text explaining the **SvgIcon** or when
   * the **SvgIcon** is purely for decoration. */
  ariaHidden: _propTypes.default.bool,
  /** Custom classes to add to the **SvgIcon** component's tag. */
  className: _propTypes.default.string,
  /** Custom classes to add to an SVG's first path tag. */
  path1ClassName: _propTypes.default.string,
  /** Custom classes to add to an SVG's second path tag. */
  path2ClassName: _propTypes.default.string,
  /** **SvgIcon** size. Options are 'lg', 'lg-minus', 'md-plus', 'md',
   * 'md-minus', 'sm-plus', 'sm', 'sm-minus', 'xs-plus', 'xs'. */
  size: _propTypes.default.oneOf(_helpers.ICON_SIZES),
  /** Title text of the SVG for assistive technologies */
  title: _propTypes.default.string
};
var _default = exports.default = SvgIcon;